import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import { getExerciseProgression, getQuestionProgression } from '../../utils/exerciseProgression';
import RadialProgress from '../RadialProgress';
import { purple } from '../../styles/_variables.scss';
import './style.scss';

const ProgressionCircles = ({ exerciseNumber, phase, questionNumber }) => {
    const {
        completedPartsCount,
        progressionPosition,
    } = useMemo(() => getQuestionProgression(phase, exerciseNumber, questionNumber), [exerciseNumber, questionNumber]);
    const progression = useMemo(() => getExerciseProgression(phase, exerciseNumber), [exerciseNumber]);
    const pieCounts = progression.length;
    const getCompletedPiePartsCount = useCallback((currentProgressionIndex) => {
        if (currentProgressionIndex < progressionPosition) {
            return progression[currentProgressionIndex];
        }
        if (currentProgressionIndex > progressionPosition) {
            return 0;
        }

        return completedPartsCount;
    }, [progression, progressionPosition, completedPartsCount]);

    const getPiePartsCount = useCallback(
        (currentProgressionIndex) => progression[currentProgressionIndex],
        [progression],
    );

    const circles = [];
    for (let i = 0; i < pieCounts; i++) {
        circles.push(
            <React.Fragment key={i}>
                <RadialProgress
                    color={purple}
                    maxValue={getPiePartsCount(i)}
                    value={getCompletedPiePartsCount(i)}
                />
                {i < pieCounts - 1 && <div className="inter-progression-circle" />}
            </React.Fragment>,
        );
    }

    return <div className="progression-circles-container">{circles}</div>;
};

ProgressionCircles.propTypes = {
    exerciseNumber: PropTypes.number.isRequired,
    phase: PropTypes.number.isRequired,
    questionNumber: PropTypes.number.isRequired,
};

export default ProgressionCircles;
